<template>
  <div>
      <div class="w3-top" style="z-index: 4" v-show="!inicial">
          <div class="w3-bar primary top-bar" style="padding: 8px 0">
              <span class="w3-bar-item top-bar-title w3-small" style="padding-top: 10px">{{comanda.nome}}</span>
              <div class="w3-right" v-show="!inicial">
                  <div class="w3-bar-item top-bar-icon" style="position: relative; padding: 6px 16px;">
                      <a href="javascript:" @click="sair">
                          <i class="fa fa-sign-out ico-notificacao"></i> <span class="w3-small">SAIR</span>
                      </a>
                  </div>
              </div>
          </div>
      </div>

     <div v-show="inicial">
         <div class="container-login w3-display-middle">
             <div>
                 <div class="w3-white w3-round w3-card">
                     <div class="img" @click="fullscreen">
                         <img class="w3-image" :src="'/static/imgs/gifs/' + gif + '.gif'"/>
                     </div>
                     <div style="padding: 1px">
                         <p><b>AGUARDANDO A LEITURA DO CARTÃO</b></p>
                     </div>
                 </div>
                 <div class="w3-margin-top">
                     <button class="w3-button primary w3-block w3-round w3-padding-16" @click="openLogin">Digitar senha</button>
                 </div>
             </div>
         </div>
     </div>

    <div style="margin-top:50px" v-show="!inicial">
      <div>
        <div class="w3-row-padding">
          <div class="w3-col l12">
              <div class="w3-white w3-padding w3-padding-16 w3-round w3-margin-top w3-center" style="position: relative">
                  <div>
                      <b v-show="saldo !== 0"> {{saldo | valor}} </b>
                      <b v-show="saldo === 0"> - </b>
                  </div>
                  <small>Saldo atual</small>
                  <div class="text-primary pointer" style="position: absolute; right: 22px; top: 22px" @click="consultarSaldo">
                      <i class="fa fa-eye-slash fa-2x" v-show="saldo === 0"></i>
                      <i class="fa fa-eye fa-2x" v-show="saldo !== 0"></i>
                  </div>
              </div>

              <busca-pdv :comanda="comanda" @atualizarComanda="atualizarTransacao" :visivel="false"/>

              <div class="w3-center w3-margin-top w3-small" style="margin-bottom: 16px">
                  <p><b>Acesso Rápido</b></p>
                  <div class="w3-row-padding">
                      <div class="w3-col s4 w3-margin-bottom" v-for="p in pesquisas">
                          <div class="w3-dark-gray w3-padding-24 w3-round pointer" @click="$emit('pesquisaRapida', p.value)">
                              {{p.name}}
                          </div>
                      </div>
                  </div>
              </div>

            <div class="w3-white w3-round" style="margin-bottom: 86px">

              <table class="w3-table w3-bordered w3-small w3-centered table-pdv">
                <thead class="w3-blue-gray">
                  <tr>
                    <th class="w3-left-align" style="width: 10%;">Data</th>
                    <th class="w3-left-align" style="width: 70%;">Produto</th>
                    <th class="w3-center" style="width: 10%;">Valor</th>
                    <th style="width: 20%;">Total</th>
                  </tr>
                </thead>
                <tbody :class="{'w3-disabled': !verificarPDV(1)}">
                  <tr v-for="p in comanda.itens" :class="{'pagamento' : p.produto.tipo === '2'}" @click="update(p)">
                    <td class="w3-left-align">{{p.produto.dt_item}}</td>
                    <td class="w3-left-align">
                      <span v-show="p.produto.tipo === '1'"><b>{{p.quantidade | qtd}}x</b>
                          {{p.produto.nome_produto}}
                          <span v-show="p.produto.principal === '0'"><b>{{' - ' + p.produto.nome_tabela}}</b></span>
                          <span v-show="p.produto.produto_adicional"><b>(Adicional)</b></span>
                      </span>
                      <span v-show="p.produto.tipo === '2'">
                          Pagamento <b v-show="p.produto.status_pagamento === '0'">(Pendente)</b>
                      </span>
                    </td>
                    <td class="w3-center">R$ {{p.produto.valor | valor}}</td>
                    <td class="w3-center">R$ {{p.produto.valor_total | valor}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
        <div class="w3-bottom" v-show="comanda && comanda.status === '1'">
            <div class="w3-button primary w3-block w3-padding-24" @click="$emit('pesquisar')">
                <i class="fa fa-cart-plus" style="padding-right: 8px"></i>
                <b>ADICIONAR</b>
            </div>
        </div>
    </div>

    <!--Componentes-->
    <detalhes-produto @atualizarProduto="atualizarProduto" @removerProduto="removerProduto"/>
    <logar />

  </div>
</template>

<script>
  import DetalhesProduto from "./DetalhesProduto"
  import Logar from "../../commons/Logar"
  import BuscaPdv from "./BuscaPDV"
  import {Money} from 'v-money'

  export default {
    components: {DetalhesProduto, BuscaPdv, Money, Logar},
    name: "pdv",

    data() {
      return {
        token: '',
        comanda: {
          nome: ''
        },
        inicial: true,
        produtoEditar: {},
        saldo: 0,

        termo: '',
        dados: {
          usuario: ''
        },

        money: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },

        gif: 5,
        sessao: '',
        pesquisas: [
          { name: 'Bebidas', value: 'Bebidas' },
          { name: 'Chocolates', value: 'Chocolates' },
          { name: 'Balas/Chicletes', value: 'Balas/Chicletes' },
          { name: 'Salgadinhos', value: 'Salgadinhos' },
          { name: 'Mendorato', value: 'Mendorato' },
          { name: 'Batom', value: 'batom' },
          { name: 'Trident', value: 'trident' },
          { name: 'Prestigio', value: 'Prestigio' },
          { name: 'Ouro Branco', value: 'Ouro Branco' },
          { name: 'Stikadinho', value: 'Stikadinho' },
          { name: 'Trento', value: 'Trento' },
          { name: 'Dadinho', value: 'Dadinho' },
        ],
      }
    },

    methods: {
      buscarTransacao(rfid) {
        document.getElementById("modal-msg").style.display="none";
        openLoading("Buscando dados");

        let dados = {
          rfid: rfid
        };

        this.$http.post(base_url + 'autenticar/rfid', dados, {emulateJSON: true})
          .then(response => {
            this.inicial = false;
            this.comanda = response.data;
            this.token = this.comanda.token;
            closeLoading();

            this.expirarUso();

          }, res => {
            this.key = '';
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      atualizarTransacao() {
        this.saldo = 0;
        let url = base_url + 'transacoes/produtos/' + this.comanda.id_transacao + '/';
        openLoading("Buscando dados");
        this.$http.get(url + this.token)
          .then(response => {
            this.comanda = response.data;
            closeLoading();

            this.expirarUso();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      update(p) {
        if (p.produto.tipo === '1') {
          this.produtoEditar = p;
          this.$emit('editarProduto', p);
        }
      },

      atualizarProduto(p, edicao) {
        if (edicao) {
          let transacao = {
            transacao: {
              id_transacao_item: this.produtoEditar.produto.id_transacao_item
            }
          };

          openLoading("Editando as informações");
          let base = "transacoes/produto/editar/" + this.token;
          Object.assign(p, transacao);

          this.$http.post(base_url + base, p, {emulateJSON: true})
            .then(res => {
              closeLoading();
              this.atualizarTransacao();

            }, res => {
              console.log(res);
              closeLoading();
              openModalMsg(res.data.result, res.data.msg);
            });
        }
      },

      removerProduto() {
        let dados = {
          id_transacao_item: this.produtoEditar.produto.id_transacao_item
        };

        openLoading("Removendo as informações");
        this.$http.post(base_url + "transacoes/produto/remover/" + this.token, dados, {emulateJSON: true})
          .then(res => {
            closeLoading();
            this.atualizarTransacao();
            //console.log(res);

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      verificarPDV(status) {
        return parseInt(this.comanda.status) === status;
      },

      consultarSaldo() {
        if (this.saldo === 0) {
          openLoading("Buscando Transações");
          let url = base_url + 'transacoes-user/' + this.comanda.id_usuario + '/';

          this.$http.get(url + localStorage.getItem('key'))
            .then(response => {
              this.saldo = parseFloat(response.data.total);
              closeLoading();

            }, res => {
              console.log(res);
              closeLoading();
              openModalMsg(res.data.result, res.data.msg, true);
            });

        } else {
          this.saldo = 0;
        }
      },

      inicializar() {
        window.scrollTo(0, 0);
        clearTimeout(this.sessao);
        this.comanda = {
          nome: ''
        };
        this.produtoEditar = {};
        this.inicial = true;
        this.key = '';
      },

      expirarUso() {
        clearTimeout(this.sessao);

        this.sessao = setTimeout(() => {
          this.$router.push('/market/');
          this.inicializar();
        }, 60 * 1000);
      },

      sair() {
        clearTimeout(this.sessao);
        this.$router.push('/market/');
        this.inicializar();
      },

      fullscreen() {
        openFullscreen()
      },

      openLogin() {
        this.$emit('openLogin');
      }
    },

    mounted: function () {
      this.inicializar();
      let id = this.$route.params.id;
      if (id) {
        this.buscarTransacao(id);
      }
      setInterval(() => {
        if (this.gif < 16) {
          this.gif++
        } else {
          this.gif = 1;
        }
      }, 1000 * 15);
    },

    created() {
      if (!localStorage.getItem("key")){
        localStorage.clear();
        this.$router.push("/login")
      }
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      },

      qtd(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      }
    }

  }
</script>

<style scoped>
    .container-login{
        width: 300px;
        text-align: center;
    }
    .container-login .img {
        height: 300px;
        display: flex;
        align-items: center;
    }

    .img img {
        width: 300px;
        max-height: 300px;
    }
    .table-pdv tr td {
        cursor: pointer;
        padding: 16px 12px;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/admin/pdv/MarketPDV.vue